import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import * as Rx from 'rxjs';
const headers = new HttpHeaders({
  'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Origin': '*',
  'Access-Control-Allow-Credentials': 'true', 'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS'
});

@Injectable()
export class AccountUserService {
  accountuserUrl = '/superadmin/rest/mgmt/account/user';
  getaccountuserUrl = '/superadmin/rest/mgmt/account/user/details';
  accountuserCountUrl = '/superadmin/rest/mgmt/account/user/count?';
  bookingStatCountUrl = '/superadmin/rest/mgmt/booking/date';
  jaldeeFeeUrl = '/superadmin/rest/mgmt/booking/payment/stats/date';
  bookingViewUrl = '/superadmin/rest/mgmt/booking/view?';
  bookingStatspCountUrl = '/superadmin/rest/mgmt/booking';
  LabelUrl = '/superadmin/rest/mgmt/account/label';
  LabelUpdateUrl = '/superadmin/rest/mgmt/account/label/edit';
  LabelCountUrl = '/superadmin/rest/mgmt/account/getlabel/count?';
  LabelgetUrl = '/superadmin/rest/mgmt/account/getlabel';
  updatePaymentUrl = '/superadmin/rest/mgmt/payment';
  constructor(private http: HttpClient) { }
  getAccountUsers(filter, sortOrder, pageNumber, pageSize = 10): Observable<any> {
    return this.http.get(this.accountuserUrl + '?' + filter, {
      params: new HttpParams()
        .set('asc', sortOrder)
        .set('from', pageNumber.toString())
        .set('count', pageSize.toString())
    });

  }
  getTotalCountByFilters(filter) {
    return this.http.get(this.LabelCountUrl + filter, { headers });
  }
  getUserById(userId) {
    return this.http.get(this.getaccountuserUrl + '/' + userId, { headers: headers });
  }
  getStat(filterparams, useragent, paymentlink): Observable<any> {
    console.log(paymentlink)
    if (useragent.length === 0 && paymentlink === undefined) {
      return this.http.get(this.bookingStatCountUrl + '/' + filterparams, { headers: headers });
    }
    else {
      if (paymentlink && useragent.length === 0) {
        return this.http.get(this.bookingStatCountUrl + '/' + filterparams + 'request_from=paymentLink:' + paymentlink, { headers: headers });
      }
      else if (paymentlink === undefined && useragent.length !== 0) {
        return this.http.get(this.bookingStatCountUrl + '/' + filterparams + 'request_from=agent:' + useragent, { headers: headers });
      }
      else {
        return this.http.get(this.bookingStatCountUrl + '/' + filterparams + 'request_from=paymentLink:' + paymentlink + '&request_from=agent:' + useragent, { headers: headers });
      }

    }

  }
  getStatBooking(filterparams): Observable<any> {
    return this.http.get(this.bookingStatCountUrl + '/' + filterparams, { headers: headers });
  }
  getFee(filterparams): Observable<any> {
    return this.http.get(this.jaldeeFeeUrl + '/' + filterparams, { headers: headers });
  }

  getStat1(DateCatogory, account, datele, datege): Observable<any> {
    return this.http.get(this.bookingStatCountUrl + '/' + DateCatogory + '/withTest' + '/' + account + '/stats' + '?' + 'date-le=' + datele + '&' + 'date-ge=' + datege, { headers: headers });
  }

  getspStat(filterparams) {
    return this.http.get(this.bookingStatspCountUrl + '/' + filterparams, { headers: headers });
  }
  getBookingView(filterparams): Observable<any> {
    return this.http.get(this.bookingViewUrl + filterparams, { headers: headers });
  }
  createLabels(formData) {
    return this.http.post(this.LabelUrl, formData, { headers: headers });
  }
  updateLabels(formData) {
    return this.http.put(this.LabelUpdateUrl, formData, { headers: headers });
  }
  changeLabelStatus(id, status) {
    return this.http.put(this.LabelUrl + '/' + id + '/' + status, { headers: headers });
  }
  getDetails(id): Observable<any> {
    return this.http.get(this.LabelUrl + '/' + id, { headers });
  }

  getLabels(filter, sortOrder, pageNumber, pageSize = 10): Observable<any> {
    return this.http.get(this.LabelgetUrl + '?' + filter, {
      params: new HttpParams()
        .set('asc', sortOrder)
        .set('from', pageNumber.toString())
        .set('count', pageSize.toString())
    });

  }
  getTotalFilterCount(filter) {
    return this.http.get(this.accountuserCountUrl + filter, { headers });
  }
  updatePaymentwithUid(uid){
    return this.http.put(this.updatePaymentUrl + '/' + uid, { headers: headers });
  }
  // getspStat(statType,DateCatogory,StatDateType,account,table){
  //   return this.http.get(this.bookingStatspCountUrl + '/' + statType + '/date' + '/'  + DateCatogory + '/dateType'+ '/'  + StatDateType + '/withTest' +'/'  + account+ '/sp' + '?' + table, { headers: headers });
  // }
}

